import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GenerateCustomerStatementRunMutationVariables = Types.Exact<{
  input: Types.GenerateCustomerStatementRunInput;
}>;


export type GenerateCustomerStatementRunMutation = { __typename?: 'Mutation', generateCustomerStatementRun: { __typename?: 'CustomerStatementRunPayload', customerStatementRun?: { __typename?: 'CustomerStatementRunData', routedCount: number, runId: string, sentCount: number, skippedCount: number, status: Types.CustomerStatementRunStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SendCustomerStatementsMutationVariables = Types.Exact<{
  input: Types.SendCustomerStatementsInput;
}>;


export type SendCustomerStatementsMutation = { __typename?: 'Mutation', sendCustomerStatements: { __typename?: 'CustomerStatementSendPayload', customerStatementRun?: { __typename?: 'CustomerStatementRunData', routedCount: number, runId: string, sentCount: number, skippedCount: number, status: Types.CustomerStatementRunStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, sends?: Array<{ __typename?: 'CustomerStatementSendOutcomeData', customerId: string, customerName: string, disposition: Types.CustomerStatementSendDisposition, reason: string, recipients: Array<string>, sent: boolean }> | null } };

export type RequestStatementPrintBatchMutationVariables = Types.Exact<{
  input: Types.RequestStatementPrintBatchInput;
}>;


export type RequestStatementPrintBatchMutation = { __typename?: 'Mutation', requestStatementPrintBatch: { __typename?: 'StatementPrintBatchPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, printBatch?: { __typename?: 'StatementPrintBatchDocument', downloadUrl?: string | null, failureReason?: string | null, printBatchId: string, renderedCount: number, statementRunId: string, status: Types.StatementPrintBatchStatus, statements: Array<{ __typename?: 'StatementPrintBatchItemDocument', customerId: string }> } | null } };


export const GenerateCustomerStatementRunDocument = new TypedDocumentString(`
    mutation GenerateCustomerStatementRun($input: GenerateCustomerStatementRunInput!) {
  generateCustomerStatementRun(input: $input) {
    customerStatementRun {
      ...CustomerStatementRun
    }
    errors {
      code
      message
    }
  }
}
    fragment CustomerStatementRun on CustomerStatementRunData {
  routedCount
  runId
  sentCount
  skippedCount
  status
}`);
export const SendCustomerStatementsDocument = new TypedDocumentString(`
    mutation SendCustomerStatements($input: SendCustomerStatementsInput!) {
  sendCustomerStatements(input: $input) {
    customerStatementRun {
      ...CustomerStatementRun
    }
    errors {
      code
      message
    }
    sends {
      customerId
      customerName
      disposition
      reason
      recipients
      sent
    }
  }
}
    fragment CustomerStatementRun on CustomerStatementRunData {
  routedCount
  runId
  sentCount
  skippedCount
  status
}`);
export const RequestStatementPrintBatchDocument = new TypedDocumentString(`
    mutation RequestStatementPrintBatch($input: RequestStatementPrintBatchInput!) {
  requestStatementPrintBatch(input: $input) {
    errors {
      code
      message
    }
    printBatch {
      ...StatementPrintBatchFields
    }
  }
}
    fragment StatementPrintBatchFields on StatementPrintBatchDocument {
  downloadUrl
  failureReason
  printBatchId
  renderedCount
  statementRunId
  statements {
    customerId
  }
  status
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GenerateCustomerStatementRun: build.mutation<GenerateCustomerStatementRunMutation, GenerateCustomerStatementRunMutationVariables>({
      query: (variables) => ({ document: GenerateCustomerStatementRunDocument, variables })
    }),
    SendCustomerStatements: build.mutation<SendCustomerStatementsMutation, SendCustomerStatementsMutationVariables>({
      query: (variables) => ({ document: SendCustomerStatementsDocument, variables })
    }),
    RequestStatementPrintBatch: build.mutation<RequestStatementPrintBatchMutation, RequestStatementPrintBatchMutationVariables>({
      query: (variables) => ({ document: RequestStatementPrintBatchDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGenerateCustomerStatementRunMutation, useSendCustomerStatementsMutation, useRequestStatementPrintBatchMutation } = injectedRtkApi;
